import React from 'react';
import { TemplateModel } from 'src/types';
import ViewCard from './view-card';
import css from './request-email-modal.module.scss';

interface TemplateViewProps {
  item: TemplateModel;
}

export default function TemplateView({ item }: Readonly<TemplateViewProps>) {
  const body = item.body.replace(/%0D%0A/g, '<br/>');

  const sendEmail = (e: React.MouseEvent<HTMLButtonElement>) => {
    window.location.href = `mailto:${item.email}?subject=${item.subject}&body=${item.body}`;
    e.preventDefault();
  };
  return (
    <div className={css.tempalteView}>
      <div className={css.info}>
        <ViewCard title='Електронна адреса' text={item.email} />
        <ViewCard title='тема листа' text={item.subject} />
        <button className={css.button} tabIndex={0} onClick={sendEmail}>
          Сформувати лист
        </button>
      </div>
      <div className={css.body}>
        <ViewCard title='тіло листа' text={body} />
      </div>
    </div>
  );
}
